import {Box, Skeleton, Stack} from "@mui/material";

import {BmTableSkeleton} from "../TableSkeleton/TableSkeleton";

export interface BmTableLayoutSkeletonProps {
  rows?: number;
  cells?: number;
}

export const BmTableLayoutSkeleton: React.FC<BmTableLayoutSkeletonProps> = ({rows = 4, cells = 3}) => (
  <Stack spacing={1}>
    <Box sx={{display: "flex", alignItems: "center", gap: 2, py: 1, px: 1, mb: 1}}>
      <Skeleton variant="rounded" height={35} sx={{flex: 1, borderRadius: 2}} />
    </Box>
    <BmTableSkeleton rows={rows} cells={cells} />
  </Stack>
);
